export const DELETE_PROJECTS_FOLDER = 'DELETE_PROJECTS_FOLDER'
